import { render, staticRenderFns } from "./client-view.vue?vue&type=template&id=d6c84628&scoped=true&lang=pug"
import script from "./client-view.js?vue&type=script&lang=js&external"
export * from "./client-view.js?vue&type=script&lang=js&external"
import style0 from "./client-view.vue?vue&type=style&index=0&id=d6c84628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c84628",
  null
  
)

export default component.exports